import React from "react";

import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Stack from "@mui/material/Stack";
import { useTheme } from "@mui/material/styles";

import { useFormContext, Controller } from "react-hook-form";
import { inputLabelStyles } from "./styles";

const ProjectMediaDefs = () => {
  const theme = useTheme();
  const {
    register,
    control,
    watch,
    formState: { errors },
  } = useFormContext();

  const watchMediaKind = watch("mediaKind");
  const watchStandalone = watch("standalone");

  const mediaSubkindOptions = React.useMemo(updateMediaSubkind, [
    watchMediaKind,
    watchStandalone,
  ]);

  function updateMediaSubkind() {
    if (watchMediaKind === "Manga") {
      let options = ["Series", "Tankobon", "Chapter", "Anthology"];
      if (watchStandalone) {
        options = [...options, "One Shot"];
      }
      return options;
    } else if (watchMediaKind === "Anime") {
      return ["Series", "Episode", "Film", "Short Film", "OVA", "ONA"];
    } else if (watchMediaKind === "CG") {
      return ["Collection"];
    } else if (watchMediaKind === "Artbook") {
      return ["Collection", "Anthology"];
    } else if (watchMediaKind === "Light Novel" || watchMediaKind === "Novel") {
      return ["Series", "Book", "Chapter"];
    } else if (watchMediaKind === "Visual Novel") {
      return ["Series", "Game", "Add-on"];
    }

    return [];
  }

  return (
    <>
      <Grid xs={4}>
        <FormControl fullWidth>
          <InputLabel {...inputLabelStyles(theme)}>Media Kind</InputLabel>
          <Controller
            control={control}
            name="mediaKind"
            render={({ field }) => (
              <Select
                id="mediaKind"
                fullWidth
                label="Media Kind"
                defaultValue="Manga"
                {...register("mediaKind", { required: true })}
                sx={{ backgroundColor: theme.palette.background.paper }}
              >
                <MenuItem value="Manga">Manga</MenuItem>
                <MenuItem value="Anime">Anime</MenuItem>
                <MenuItem value="CG">CG</MenuItem>
                <MenuItem value="Artbook">Artbook</MenuItem>
                <MenuItem value="Light Novel">Light Novel</MenuItem>
                <MenuItem value="Novel">Novel</MenuItem>
                <MenuItem value="Visual Novel">Visual Novel</MenuItem>
              </Select>
            )}
          />
        </FormControl>
      </Grid>

      <Grid xs={4}>
        <FormControl fullWidth>
          <InputLabel {...inputLabelStyles(theme)}>Media Subkind</InputLabel>
          <Controller
            control={control}
            name="mediaSubkind"
            render={({ field }) => (
              <Select
                id="mediaSubkind"
                fullWidth
                label="Media Subkind"
                sx={{ backgroundColor: theme.palette.background.paper }}
                defaultValue={mediaSubkindOptions[0]}
                // value={ (field.value !== '') ? field.value : mediaSubkindOptions[0] }
                {...register("mediaSubkind", { required: true })}
              >
                {mediaSubkindOptions.map((name, index) => (
                  <MenuItem key={`${name}-${index}`} value={name}>
                    {name}
                  </MenuItem>
                ))}
              </Select>
            )}
          />
        </FormControl>
      </Grid>

      <Grid xs={4}>
        <Stack>
          <FormControl>
            <FormControlLabel
              label="Standalone"
              control={
                <Controller
                  control={control}
                  name="standalone"
                  render={({ field }) => (
                    <Checkbox
                      sx={{
                        color: "#fff",
                        "&Mui-Checked": { color: "primary" },
                        "& .MuiSvgIcon-root": { fontSize: 32 },
                      }}
                      {...register("standalone")}
                    />
                  )}
                />
              }
            />
          </FormControl>

          <FormControl>
            <FormControlLabel
              label="Doujin"
              control={
                <Controller
                  control={control}
                  name="standalone"
                  render={({ field }) => (
                    <Checkbox
                      sx={{
                        color: "#fff",
                        "&Mui-Checked": { color: "primary" },
                        "& .MuiSvgIcon-root": { fontSize: 32 },
                      }}
                      {...register("doujin")}
                    />
                  )}
                />
              }
            />
          </FormControl>
        </Stack>
      </Grid>
      </>
  );
};

export default ProjectMediaDefs;
